// Utils
import { isWebBridgeSupported } from '@shopee/web-bridge-sdk';

// Types
import type { AddOrChangeEmailExitHandling } from '@shopee-user/business-customization-types';

export function addOrChangeEmailExitHandling({
  nonce,
  isWebViewLogoutAfterCredentialChangeEnabled,
  webViewLogoutSuccessfully,
  webViewNotifyRefreshTokenAfterChangeCredentials,
  exitWithSuccess,
  safelyRedirectToNextUrlFromQueryString,
}: AddOrChangeEmailExitHandling) {
  if (isWebBridgeSupported()) {
    if (isWebViewLogoutAfterCredentialChangeEnabled) {
      webViewLogoutSuccessfully();
    } else {
      webViewNotifyRefreshTokenAfterChangeCredentials({ nonce });
      exitWithSuccess();
    }
  } else {
    safelyRedirectToNextUrlFromQueryString({ code: nonce });
  }
}
